import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.latestMetrics && _vm.get(_vm.latestMetrics, 'data.dataPoints.length') ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.currentDataPoints')))]), _c(VSimpleTable, {
    attrs: {
      "fixed-header": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("CA")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("IOA")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.type')))]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.value')))]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Flags")])])]), _c('tbody', [_vm._l(_vm.latestMetrics.data.dataPoints, function (dp, index) {
          return [_c('tr', {
            key: index
          }, [_c('td', [_vm._v("\n                " + _vm._s(dp.ca) + "\n              ")]), _c('td', [_vm._v("\n                " + _vm._s(dp.ioa) + "\n              ")]), _c('td', [_vm._v("\n                " + _vm._s(dp.type) + "\n              ")]), _c('td', [_vm._v("\n                " + _vm._s(dp.value) + "\n              ")]), _c('td', [dp.flags.length ? _c(VIcon, {
            attrs: {
              "color": _vm.color,
              "x-small": ""
            }
          }, [_vm._v("fal fa-flag")]) : _vm._e(), _vm._v("\n                " + _vm._s(dp.flags.join(',') || '-') + "\n              ")], 1)])];
        })], 2)];
      },
      proxy: true
    }], null, false, 1575639839)
  })], 1) : _vm._e(), _c(VDivider, {
    staticClass: "mt-12"
  }), _c(VDataTable, {
    attrs: {
      "items": _vm.metrics,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeaders,
      "loading": _vm.isFetching,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(items.item.data.port))]), _c('td', [_vm._v(_vm._s(items.item.data.status))]), _c('td', [_vm._v(_vm._s(_vm.localizeDate(items.item.data.lastConfigChange)))]), _c('td', [_vm._v(_vm._s(_vm.localizeDate(items.item.data.lastDataUpdate)))]), _c('td', [_vm._v(_vm._s(items.item.data.numConnectedClients))])])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };